import React from 'react'

interface ContactEmailProps {
  email: string | undefined | null
  label?: string
}

const ContactEmail: React.FC<ContactEmailProps> = ({
  email,
  label = 'Email',
}) => {
  return (
    <div className="text-sm flex items-center gap-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        className="text-gray-800"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
      <span className="font-medium">{label}:</span> {email}
    </div>
  )
}

export default ContactEmail
